import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { EventCateringApprovalListItemDTO } from '../../../../dto/event/event-catering-approval-list-item.dto';
import { Router } from '@angular/router';
import {
  buildCateringApprovalStatusColumn,
  buildCateringApprovedAtColumn,
  buildCateringDualCountColumns,
  buildCateringNameLocationColumns,
  buildCateringPreferencesIconColumn,
  buildEventScheduleColumn,
  buildEventViewIconColumn,
  CATERING_EVENT_LIST_TABLE_BASE,
} from './duna_catering_list.shared';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function duna_catering_unique_pending(componentDataSourceService: ComponentDataSourceService) {
  const router = componentDataSourceService.injector.get(Router);

  return {
    name: 'DUNA Catering Unique Pending',
    description: 'Catering-events for link user that are pending or need reapproval',
    execute: (params?: LoadDataParams): Observable<any> => {
      const urlWithoutQuery = (router.url || '').split('?')[0];
      const linkUuid = urlWithoutQuery.split('/').find((segment) => UUID_REGEX.test(segment));
      if (!linkUuid) {
        return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
      }

      const mergedFilters = [...(params?.filters || [])];
      if (!mergedFilters.some((f) => f.column === 'status')) {
        mergedFilters.push({ column: 'status', value: 'pending', operator: 'equals' } as any);
      }
      if (!mergedFilters.some((f) => f.column === 'include_no_participants')) {
        mergedFilters.push({ column: 'include_no_participants', value: true, operator: 'equals' } as any);
      }

      const requestParams: LoadDataParams = {
        ...(params || ({} as any)),
        dataSourceKey: 'duna_catering_unique_pending',
        filters: mergedFilters
      };

      return componentDataSourceService['loadDataWithStandardFiltersGET'](
        'duna_catering_unique_pending',
        `/events/catering/unique-links/${linkUuid}/events`,
        requestParams
      ).pipe(
        catchError((error) => {
          console.error('Error fetching unique pending catering approvals:', error);
          return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
        }),
        map((result) => {
          const items = (result?.items || []) as EventCateringApprovalListItemDTO[];
          return {
            items,
            totalCount: result?.totalCount ?? items.length,
            pageSize: result?.pageSize ?? 10,
            pageIndex: result?.pageIndex ?? 0,
            filters: result?.filters
          };
        })
      );
    },
    settings: {
      columns: [
        buildEventScheduleColumn(),
        ...buildCateringNameLocationColumns(),
        ...buildCateringDualCountColumns(),
        buildCateringApprovedAtColumn(),
        buildCateringApprovalStatusColumn(),
        buildCateringPreferencesIconColumn(),
        buildEventViewIconColumn(router),
      ],
      ...CATERING_EVENT_LIST_TABLE_BASE,
    }
  };
}
